"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitFeedback = exports.submitBiofuelOffer = exports.submitQuoteRequest = exports.submitInputs = exports.submitForm = exports.FORM_FEEDBACK = exports.FORM_BIOFUEL = exports.FORM_QUOTE = exports.FORM_INPUTS = void 0;
/**
 * Netlify Forms matches a urlencoded POST to a form by its `form-name` field.
 * Every form is declared as static markup in public/__forms.html: Netlify
 * discovers forms by parsing deployed HTML at build time and never sees what
 * React renders. Posting to that real file also keeps the single-page-app
 * catch-all rewrite in netlify.toml from swallowing the request.
 *
 * Any field posted here must exist in that declaration or it will not be kept.
 */
const ENDPOINT = "/__forms.html";
exports.FORM_INPUTS = "calculator-inputs";
exports.FORM_QUOTE = "quote-request";
exports.FORM_BIOFUEL = "biofuel-offer";
exports.FORM_FEEDBACK = "feedback";
const submitForm = async (formName, fields) => {
    const body = new URLSearchParams({
        "form-name": formName,
        "bot-field": "",
        ...fields,
    });
    try {
        const response = await fetch(ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString(),
        });
        return response.ok;
    }
    catch {
        return false;
    }
};
exports.submitForm = submitForm;
/** The figures behind a calculation, shared by every enquiry so context travels with it. */
const figures = (inputs, result) => ({
    fossil: result.fuel.name,
    tons: String(inputs.tons),
    ciBio: String(inputs.ciBio),
    priceFossil: String(inputs.priceFossil),
    priceBio: String(inputs.priceBio),
    poolPriceEur: String(inputs.poolPriceEur),
    eua: String(inputs.eua),
    fx: String(inputs.fx),
    surplus: result.surplus.toFixed(1),
    poolNet: result.poolNet.toFixed(0),
    offsetNet: result.offsetNet.toFixed(0),
});
/**
 * Figures only — no contact details. This is the anonymous record kept when the
 * operator has allowed it, and it must stay separable from the enquiries below,
 * which carry personal data and are sent on the operator's own initiative.
 */
const submitInputs = (inputs, result) => (0, exports.submitForm)(exports.FORM_INPUTS, figures(inputs, result));
exports.submitInputs = submitInputs;
const submitQuoteRequest = (inputs, result, contact) => (0, exports.submitForm)(exports.FORM_QUOTE, {
    ...figures(inputs, result),
    email: contact.email,
    phone: contact.phone,
    topics: contact.topics.join(", "),
    ets: result.ets.toFixed(0),
    premium: result.premium.toFixed(0),
    poolProfit: result.poolProfit.toFixed(0),
    penaltyAvoided: result.penaltyAvoided.toFixed(0),
});
exports.submitQuoteRequest = submitQuoteRequest;
const submitBiofuelOffer = (inputs, result, contact) => (0, exports.submitForm)(exports.FORM_BIOFUEL, {
    ...figures(inputs, result),
    email: contact.email,
    phone: contact.phone,
    imo: contact.imo,
});
exports.submitBiofuelOffer = submitBiofuelOffer;
const submitFeedback = (message, email) => (0, exports.submitForm)(exports.FORM_FEEDBACK, { message, email });
exports.submitFeedback = submitFeedback;
